<template>
  <div :class="style.widgetMainBlock">
    <button :class="style.openWidget" @click="open = true">
      <div :class="style.listImg">
        <img v-for="img in getImgDoctor" :src="img" alt="" />
        <div :class="style.circle" />
      </div>
      <span>Онлайн<br />запись</span>
    </button>
  </div>
</template>
<script lang="ts">
import style from "../StyleWidget.module.scss";
import {defineComponent} from "vue";
export default defineComponent({
  name: "OpenWidgetButton",
  data() {
    return {
      style,
      open: false
    };
  },
  computed: {
    getImgDoctor() {
      return this.$widgetStore.getImgDoctor;
    }
  },
  watch: {
    open(data) {
      this.$emit("update:modelValue", data);
    }
  }
});
</script>
